import { TemplateData, TemplateParams } from '.';

const courseAccessRequestDeny = ({
  defaultPlaceholders,
  messages,
  serverConfig
}: TemplateParams): TemplateData => ({
  category: 'courses',
  email: {
    buttonEnabled: true,
    buttonLink: '{{courseUrl}}',
    buttonText: messages.authSignIn,
    content: `
      <p>
        ${messages.courseAccessRequestDeny}
      </p>
      <p>
        {{optionalMessage}}
      </p>`,
    contentAfterButton: `
      <p>
        ${messages.emailSignatureText}
      </p>`,
    footnote: `${messages.emailContentClarification} {{contactEmail}}`,
    heading: messages.emailGreeting,
    subject: `{{siteName}}: ${messages.courseAccessToCourse}`
  },
  placeholders: {
    courseTitle: {
      label: messages.coursesCourseTitle,
      example: 'Test course'
    },
    courseUrl: {
      label: messages.commonCourseLink,
      example: `${serverConfig.adminUrl}/courses/test-course`
    },
    optionalMessage: {
      label: messages.courseAccessRequestAdminMessage,
      example: 'You do not have permission for this course.'
    },
    ...defaultPlaceholders
  },
  title: messages.emailTypeCourseAccessRequestDeny
});

export default courseAccessRequestDeny;
